import { useQuery } from "@tanstack/react-query";
import { getTeam } from "../../api";

export const useGetTeam = (page) => {
  const query = useQuery({
    queryKey: ["team", page],
    queryFn: () => getTeam(page),
  });

  return {
    isLoading: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    data: query.data,
    refetch: query.refetch,
  };
};
